"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveItem = void 0;
/**
 * Moves an item from one position to another, checking that the indexes given are within bounds.
 *
 * @example
 * const source = observable([1, 2, 3])
 * moveItem(source, 0, 1)
 * console.log(source.map(x => x)) // [2, 1, 3]
 *
 * @export
 * @param {ObservableArray<T>} target
 * @param {number} fromIndex
 * @param {number} toIndex
 * @returns {ObservableArray<T>}
 */
function moveItem(target, fromIndex, toIndex) {
    checkIndex(target, fromIndex);
    checkIndex(target, toIndex);
    if (fromIndex === toIndex) {
        return;
    }
    var oldItems = target.slice();
    var newItems;
    if (fromIndex < toIndex) {
        newItems = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], oldItems.slice(0, fromIndex), true), oldItems.slice(fromIndex + 1, toIndex + 1), true), [
            oldItems[fromIndex]
        ], false), oldItems.slice(toIndex + 1), true);
    }
    else {
        // toIndex < fromIndex
        newItems = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], oldItems.slice(0, toIndex), true), [
            oldItems[fromIndex]
        ], false), oldItems.slice(toIndex, fromIndex), true), oldItems.slice(fromIndex + 1), true);
    }
    target.replace(newItems);
    return target;
}
exports.moveItem = moveItem;
/**
 * Checks whether the specified index is within bounds. Throws if not.
 *
 * @private
 * @param {ObservableArray<any>} target
 * @param {number }index
 */
function checkIndex(target, index) {
    if (index < 0) {
        throw new Error("[mobx.array] Index out of bounds: ".concat(index, " is negative"));
    }
    var length = target.length;
    if (index >= length) {
        throw new Error("[mobx.array] Index out of bounds: ".concat(index, " is not smaller than ").concat(length));
    }
}
//# sourceMappingURL=array-utils.js.map